import IdleJs from 'idle-js';
import { deviceIsNotActive } from './device.service';

let idle = null;

export default {
    start() {
        idle = new IdleJs({
            idle: 5 * 1000 * 60, // 5 min
            events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
            onIdle: () => {
                this.restart();
            },
            keepTracking: true,
            startAtIdle: false
        });
        idle.start();
    },
    restart() {
        try {
            deviceIsNotActive();
        } catch (error) {
            console.log('Failed request "device is not active"', error);
        } finally {
            idle.stop()
                .reset()
                .start();
        }
    }
};



// WEBPACK FOOTER //
// ./skins/xkiosk/services/idle.service.js